<template>
  <BDropdown
    ref="dropdown"
    variant="link"
    right
    no-caret
    class="news-bell"
    menu-class="news-bell-menu"
    @show="load"
  >
    <template #button-content>
      <div class="user-icon position-relative">
        <i class="far fa-bell" />
        <span
          v-if="unreadNews"
          class="badge badge-pill badge-danger news-bell-count"
        >{{ unreadNews > 10 ? '10+' : unreadNews }}</span>
      </div>
    </template>

    <div class="d-flex justify-content-between align-items-center px-3 pb-2">
      <div class="font-weight-bold">
        {{ $t('news.title') }}
      </div>
      <button
        v-if="unreadNews"
        class="btn btn-link btn-sm p-0"
        @click.stop="markAll"
      >
        <i class="far fa-check-double mr-1" />
        {{ $t('news.markAllRead') }}
      </button>
    </div>

    <div class="dropdown-divider m-0" />

    <div
      v-if="loading"
      class="text-center py-3"
    >
      <Loader size="20px" />
    </div>
    <div
      v-else-if="items.length === 0"
      class="text-center text-secondary small py-3"
    >
      {{ $t('news.empty') }}
    </div>
    <template v-else>
      <div
        v-for="item in items"
        :key="item.id"
        class="news-bell-item"
        :class="{ unread: item.unread }"
        @click="open(item)"
      >
        <div class="flex-grow-1">
          <NewsLabels :item="item" />
          <div class="news-bell-title">
            {{ item.title }}
          </div>
          <div class="news-bell-summary">
            {{ item.summary }}
          </div>
        </div>
        <span
          v-if="item.unread"
          class="news-unread-dot"
        />
      </div>
    </template>

    <div class="dropdown-divider m-0" />
    <div
      class="text-center pt-2"
    >
      <RouterLink
        :to="`/payee/${payeeId}/messages/news`"
        class="small"
        @click.native="close"
      >
        {{ $t('news.seeAll') }}
        <i class="far fa-arrow-right ml-1" />
      </RouterLink>
    </div>
  </BDropdown>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import NewsLabels from './NewsLabels';

const BELL_ITEMS = 5;

export default {
  data: () => ({
    items: [],
    loading: false,
  }),
  components: {
    NewsLabels,
  },
  computed: {
    ...mapGetters(['payeeId', 'unreadNews']),
  },
  methods: {
    ...mapActions(['getNews', 'markAllNewsRead']),
    async load() {
      this.loading = true;
      try {
        const data = await this.getNews();
        this.items = (data.list || []).slice(0, BELL_ITEMS);
      } catch {
        this.items = [];
      } finally {
        this.loading = false;
      }
    },
    async markAll() {
      await this.markAllNewsRead();
      this.items = this.items.map((x) => ({ ...x, unread: false }));
    },
    open(item) {
      this.close();
      this.$router.push(`/payee/${this.payeeId}/messages/news/${item.id}`);
    },
    close() {
      if (this.$refs.dropdown) {
        this.$refs.dropdown.hide(true);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/vars';

.news-bell-count {
  position: absolute;
  top: -6px;
  right: -10px;
  font-size: 10px;
}

.news-bell ::v-deep .dropdown-toggle {
  box-shadow: none !important;
}

.news-bell ::v-deep .news-bell-menu {
  width: 400px;
  padding: 8px 0;
  // Above the pages' .sticky-top toolbars (z-index 1020).
  z-index: 1030;
}

.news-bell-item {
  display: flex;
  gap: 10px;
  padding: 10px 16px;
  cursor: pointer;
  border-bottom: 1px solid #eee;

  &:hover {
    background-color: #f6f6f6;
  }

  &.unread {
    background-color: rgba($blue, 0.05);
  }
}

.news-bell-title {
  font-weight: 500;
  font-size: 14px;
  margin-top: 3px;
}

.news-bell-summary {
  font-size: 12px;
  color: #666;
  white-space: normal;
}

.news-unread-dot {
  width: 8px;
  height: 8px;
  min-width: 8px;
  border-radius: 50%;
  background: $blue;
  margin-top: 6px;
}
</style>
